import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { SwitchTradeForm } from './SwitchTradeForm'

export function SwitchTradeCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.unitlink.useSwitchTradeActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  // This command has been deprecated. But we still need the ability to cancel and approve existing commands.
  if (props.commandActionVariant === 'create') {
    return null
  }

  return (
    <CommandModalButton
      actionId="unitLink.SwitchTradeCommandData"
      title={translate('switchTradeModalButton.title')}
      commandDataForm={SwitchTradeForm}
      {...props}
      submit={submit}
    />
  )
}
